import { formatUnitPrice } from "services/api/pricing/consts";
import { PricingSchemeItem } from "services/api/pricing/schemeTypes";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

const formatAdjustment = (item: PricingSchemeItem): string => {
  if (item.adjustmentType === "Absolute") {
    return formatUnitPrice.format(item.value);
  }

  const sign = item.value > 0 ? "+" : "";

  return `${sign}${item.value.toFixed(2).replace(".", ",")} %`;
};

export const SCHEME_ITEM_COLUMNS: Column[] = [
  {
    title: "Ključ",
    field: "keyCode",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingSchemeItem) => (
      <span className="font-mono text-xs text-slate-600">{row.keyCode}</span>
    ),
  },
  {
    title: "Tip",
    field: "adjustmentType",
    sortable: true,
    type: ColumnTypes.custom,
    // Fiksni iznos prestaje pratiti cjenik — to mora biti vidljivo na prvi pogled.
    render: (row: PricingSchemeItem) =>
      row.adjustmentType === "Absolute" ? (
        <Badge text="Fiksno — ne prati cjenik" variant="warning" height="small" />
      ) : (
        <span className="text-slate-500">Postotak</span>
      ),
  },
  {
    title: "Promjena",
    field: "value",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingSchemeItem) => (
      <span className="font-semibold text-slate-700 whitespace-nowrap">
        {formatAdjustment(row)}
      </span>
    ),
  },
];
